export * from './lottieAnimationView.module';

export {LottieAnimationViewComponent} from './lottieAnimationView.component';
